<p
  class="p-30 pb-0"
  style="
    color: #001e3c;
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 38px;
  "
>
  Forms
</p>
<!-- /* Typography */ -->
<div class="card">
  <p
    style="
      font-size: 18px;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 23px;
      color: #0054be;
    "
  >
    Accordions
  </p>

  <div class="custom-accordion mb-3">
    <ngb-accordion #acc="ngbAccordion">
      <ngb-panel>
        <ng-template class="d-flex align-items-center" ngbPanelTitle>
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <img
                width="50"
                height="50"
                style="border-radius: 50%"
                src="./../../../assets/images/User.jpg"
              />
              <div class="ml-2">
                <p class="mb-1">Hasta Adı Soyadı</p>
                <p class="body-heading m-0">Emre Uslu</p>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="ml-2">
                <p class="mb-1">Tc Kimlik No</p>
                <p class="body-heading m-0">18019039034</p>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="ml-2">
                <p class="mb-1">Doğum Tarihi</p>
                <p class="body-heading m-0">26.04.1976</p>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="ml-2">
                <p class="mb-1">Hizmet Alan</p>
                <p class="body-heading m-0">Kendisi</p>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="ml-2">
                <p class="mb-1">Üye Durumu</p>
                <p class="body-heading warning-color m-0">SHY</p>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="ml-2">
                <p class="mb-1">Üye Statüsü</p>
                <p class="body-heading m-0">Kendisi</p>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="ml-2">
                <p class="mb-1">Provizyon No</p>
                <p class="body-heading m-0">318188</p>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="ml-2">
                <p class="mb-1">Değerlendirme Durumu</p>
                <p class="body-heading m-0">Fatura kesimi için bekleniyor…</p>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="ml-2">
                <p class="mb-1">Provizyon/Hizmet Zamanı</p>
                <p class="body-heading m-0">04.08.2022</p>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="ml-2">
                <p class="mb-1">Tevkifatlı mı?</p>
                <div class="checkbox">
                  <input id="checkbox1" type="checkbox" />
                  <label for="checkbox1"></label>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="ml-2">
                <i class="far fa-chevron-down"></i>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <div class="card-body__content d-flex">
            <div class="d-flex">
              <div class="mr-1">
                <span>SGK: &nbsp;</span>
                <span class="body-heading m-0">Anlaşmalı Değil</span>
              </div>
              <div class="ml-4 mr-1">
                <span>SGK Tutarı: &nbsp;</span>
                <span class="body-heading m-0">0</span>
              </div>
              <div class="ml-4 mr-1 warning-color">
                <span>SHY Katkı Payı Tutarı: &nbsp;</span>
                <span class="body-heading m-0">54,50</span>
              </div>
              <div class="ml-4 mr-1">
                <span>Tutar (KDV’li): &nbsp;</span>
                <span class="body-heading m-0">54,50</span>
              </div>
              <div class="ml-4 mr-1">
                <span>Tutar (KDV’siz): &nbsp;</span>
                <span class="body-heading m-0">54,50</span>
              </div>
              <div class="ml-4 mr-1">
                <span>Hesaplanan KDV (%8): &nbsp;</span>
                <span class="body-heading m-0">16,02</span>
              </div>
              <div class="ml-4 mr-1">
                <span>Vergiler Dahil Tutar: &nbsp;</span>
                <span class="body-heading m-0">216,22</span>
              </div>
              <div class="ml-4 success-color">
                <span>Ödenecek Tutar: &nbsp;</span>
                <span class="body-heading m-0">216,22</span>
              </div>
              <div class="ml-4 danger-color">
                <span>Red Tutar (KDV’li): &nbsp;</span>
                <span class="body-heading m-0">0</span>
              </div>
            </div>
          </div>
          <div class="card-body__bottom">
            <i class="fas fa-info-circle mr-2"></i
            ><span>Katkı payı üye tarafından ödenecektir!</span>
          </div>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>
  </div>
  <div class="success-bar mb-3">
    <i class="fas fa-info-circle mr-2 f-18"></i
    ><span
      >Sorgulanan üyemiz sağlık kapsamındadır. Sağlık işlemleri için kişi
      müstehaktır.</span
    >
  </div>

  <div class="custom-accordion2">
    <ngb-accordion #acc="ngbAccordion">
      <ngb-panel>
        <ng-template class="d-flex align-items-center" ngbPanelTitle>
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex flex-column">
              <h3>Aile Hekimliği/Mehmet Türk</h3>
              <div class="d-flex mt-3">
                <div class="mr-1">
                  <span>SGK: &nbsp;</span>
                  <span class="body-heading m-0">Anlaşmalı</span>
                </div>
                <div class="ml-4 mr-1">
                  <span>Tutar (KDV’li): &nbsp;</span>
                  <span class="body-heading m-0">0</span>
                </div>
                <div class="ml-4 mr-1">
                  <span>Tutar (KDV’siz): &nbsp;</span>
                  <span class="body-heading m-0">0</span>
                </div>
                <div class="ml-4 mr-1">
                  <span>Tutar: &nbsp;</span>
                  <span class="body-heading m-0">0</span>
                </div>
                <div class="ml-4">
                  <span>Red Tutar (KDV’li): &nbsp;</span>
                  <span class="body-heading m-0">0</span>
                </div>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <div class="ml-2">
                <i class="far fa-chevron-down"></i>
              </div>
            </div>
          </div>
        </ng-template>
        <ng-template ngbPanelContent> 123 </ng-template>
      </ngb-panel>
    </ngb-accordion>
  </div>

  <p
    class="mt-5"
    style="
      font-size: 18px;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 23px;
      color: #0054be;
    "
  >
    Grids
  </p>

  <form class="theme-form">
    <div class="row">
      <div class="col-lg-4">
        <div class="form-group m-b-15">
          <label class="label">Teminatlar</label>
          <select class="form-control">
            <option selected>Tüm Teminatlar</option>
            <option>Teminat 1</option>
            <option>Teminat 2</option>
            <option>Teminat 3</option>
          </select>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="form-group m-b-15">
          <label class="label">Arama</label>
          <div class="text-icon">
            <input
              type="text"
              placeholder="Kod, Teminat, Alt Teminat ile Arama"
              class="form-control"
            />
            <span class="far fa-search"></span>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col">Hizmet Ekle</th>
          <th scope="col">Kod</th>
          <th scope="col">Teminat</th>
          <th scope="col">Alt Teminat</th>
          <th scope="col">Tedavi</th>
          <th scope="col">İskonto Oranı</th>
          <th scope="col">Değer</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><span class="far fa-plus m-l-30"></span></td>
          <td>24.044</td>
          <td>Radyoloji</td>
          <td>Bilgisayarlı Tomogrofi(BT)</td>
          <td>Bilgisayarlı alt abonmen tomogrofisi(MD veya S)</td>
          <td>90</td>
          <td>100</td>
        </tr>
        <tr>
          <td><span class="far fa-plus m-l-30"></span></td>
          <td>24.044</td>
          <td>Radyoloji</td>
          <td>Bilgisayarlı Tomogrofi(BT)</td>
          <td>Bilgisayarlı alt abonmen tomogrofisi(MD veya S)</td>
          <td>90</td>
          <td>100</td>
        </tr>
        <tr>
          <td><span class="far fa-plus m-l-30"></span></td>
          <td>24.044</td>
          <td>Radyoloji</td>
          <td>Bilgisayarlı Tomogrofi(BT)</td>
          <td>Bilgisayarlı alt abonmen tomogrofisi(MD veya S)</td>
          <td>90</td>
          <td>100</td>
        </tr>
        <tr>
          <td><span class="far fa-plus m-l-30"></span></td>
          <td>24.044</td>
          <td>Radyoloji</td>
          <td>Bilgisayarlı Tomogrofi(BT)</td>
          <td>Bilgisayarlı alt abonmen tomogrofisi(MD veya S)</td>
          <td>90</td>
          <td>100</td>
        </tr>
      </tbody>
    </table>
  </div>

  <label class="label m-t-30"
    >Eklenen Hizmetler<span class="table-counter">2</span></label
  >
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col">İşlem No</th>
          <th scope="col">Teminat</th>
          <th scope="col">Kod</th>
          <th scope="col">Ad</th>
          <th scope="col">Ödenen Tutar (KDV'li)</th>
          <th scope="col">Ödenen Tutar (KDV'siz)</th>
          <th scope="col">Ödenen Tutar</th>
          <th scope="col">Red Tutar( KDV'li)</th>
          <th scope="col">KDV Tevkifatlı mı?</th>
          <th scope="col">İşlemler</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1331218</td>
          <td>Radyoloji</td>
          <td>10.0030</td>
          <td>Bronoskopi, Bronkoalveolar lavaj</td>
          <td>4.246,32</td>
          <td>4.000,00</td>
          <td>4.146,32</td>
          <td>0</td>
          <td>
            <div class="d-flex align-center justify-content-center checkbox">
              <input id="checkbox3" type="checkbox" /><label
                for="checkbox3"
              ></label>
            </div>
          </td>
          <td>
            <span class="fas fa-pen"></span
            ><span class="far fa-trash-alt m-l-30"></span>
          </td>
        </tr>
        <tr>
          <td>1331254</td>
          <td>İlaç</td>
          <td>20.9994</td>
          <td>İlaç</td>
          <td>1.783,78</td>
          <td>1.651,83</td>
          <td>1.683,78</td>
          <td>0</td>
          <td>
            <div class="d-flex align-center justify-content-center checkbox">
              <input id="checkbox2" type="checkbox" /><label
                for="checkbox2"
              ></label>
            </div>
          </td>
          <td>
            <span class="fas fa-pen"></span
            ><span class="far fa-trash-alt m-l-30"></span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="table-delete-items">
    <div class="table-delete-items__content">
      <span class="far fa-trash-alt m-l-30">&nbsp;&nbsp;</span><span>2</span
      ><span>&nbsp;İşlem Sil</span>
    </div>
  </div>

  <label class="label m-t-30"
    >Eklenen Hizmetler<span class="table-counter">0</span></label
  >
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col">İşlem No</th>
          <th scope="col">Teminat</th>
          <th scope="col">Kod</th>
          <th scope="col">Ad</th>
          <th scope="col">Ödenen Tutar (KDV'li)</th>
          <th scope="col">Ödenen Tutar (KDV'siz)</th>
          <th scope="col">Ödenen Tutar</th>
          <th scope="col">Red Tutar( KDV'li)</th>
          <th scope="col">KDV Tevkifatlı mı?</th>
          <th scope="col">İşlemler</th>
        </tr>
      </thead>
      <tbody class="empty">
        <tr>
          <td colspan="10">Henüz Provizyon Girilmedi.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <label class="label m-t-30">Optik Tablo</label>
  <div class="table-responsive m-b-30">
    <table class="table table-optik-list">
      <thead>
        <tr>
          <th scope="col">Cam Türü</th>
          <th scope="col">Gözlük Türü</th>
          <th scope="col">Çerçeve</th>
          <th scope="col">Cam</th>
          <th scope="col">SPH</th>
          <th scope="col">CYL</th>
          <th scope="col">AKS</th>
          <th scope="col">Tutar</th>
          <th scope="col">
            <label class="switch">
              <input type="checkbox" checked />
              <span class="slider round"></span>
            </label>
            SGK Tutarı
          </th>
          <th scope="col">Çerçeve Tutarı</th>
          <th class="success-color" scope="col">Toplam Tutar</th>
          <th scope="col">İşlemler</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td rowspan="2">Organik Antiferle</td>
          <td rowspan="2">Uzak</td>
          <td rowspan="2">Var</td>
          <td>Sağ</td>
          <td>3.25</td>
          <td>4.50</td>
          <td>80°</td>
          <td>50,75</td>
          <td>15,50</td>
          <td rowspan="2">320,50</td>
          <td class="success-color" rowspan="2">320,50</td>
          <td rowspan="2">
            <span class="fas fa-pen"></span
            ><span class="far fa-trash-alt m-l-30"></span>
          </td>
        </tr>
        <tr>
          <td>Sol</td>
          <td>3.15</td>
          <td>4.25</td>
          <td>90°</td>
          <td>115</td>
          <td>25</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="table-responsive">
    <table class="table table-optik-list">
      <thead>
        <tr>
          <th scope="col">Cam Türü</th>
          <th scope="col">Gözlük Türü</th>
          <th scope="col">Çerçeve</th>
          <th scope="col">Cam</th>
          <th scope="col">SPH</th>
          <th scope="col">CYL</th>
          <th scope="col">AKS</th>
          <th scope="col">Tutar</th>
          <th class="disable-color" scope="col">
            <label class="switch">
              <input type="checkbox" />
              <span class="slider round"></span>
            </label>
            SGK Tutarı
          </th>
          <th scope="col">Çerçeve Tutarı</th>
          <th class="success-color" scope="col">Toplam Tutar</th>
          <th scope="col">İşlemler</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td rowspan="2">Organik Antiferle</td>
          <td rowspan="2">Uzak</td>
          <td rowspan="2">Var</td>
          <td>Sağ</td>
          <td>3.25</td>
          <td>4.50</td>
          <td>80°</td>
          <td>50,75</td>
          <td class="disable-color">15,50</td>
          <td rowspan="2">320,50</td>
          <td class="success-color" rowspan="2">320,50</td>
          <td rowspan="2">
            <span class="fas fa-pen"></span
            ><span class="far fa-trash-alt m-l-30"></span>
          </td>
        </tr>
        <tr>
          <td>Sol</td>
          <td>3.15</td>
          <td>4.25</td>
          <td>90°</td>
          <td>115</td>
          <td class="disable-color">25</td>
        </tr>
      </tbody>
    </table>
  </div>

  <p
    class="mt-5"
    style="
      font-size: 18px;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 23px;
      color: #0054be;
    "
  >
    Others
  </p>

  <div class="cc-wrapper">
    <div class="cc">
      <div class="cc__top">
        <div class="cc__top__icon">ICON</div>
        <div class="cc__top__content">
          <p class="cc__top__content__title">
            ICD Kodu Girilmemiş Provizyonlar
          </p>
          <span class="cc__top__content__mega-text">33</span>
        </div>
      </div>
      <div class="cc__bottom">
        <a href="#" class="cc__bottom__button">Tüm Liste</a>
      </div>
    </div>
    <div class="cc">
      <div class="cc__top">
        <div class="cc__top__icon">ICON</div>
        <div class="cc__top__content">
          <p class="cc__top__content__title">
            ICD Kodu Girilmemiş Provizyonlar
          </p>
          <span class="cc__top__content__mega-text">-</span>
        </div>
      </div>
      <div class="cc__bottom">
        <a href="#" class="cc__bottom__button">Tüm Liste</a>
      </div>
    </div>
    <div class="cc">
      <div class="cc__top">
        <div class="cc__top__icon">ICON</div>
        <div class="cc__top__content">
          <p class="cc__top__content__title">
            ICD Kodu Girilmemiş Provizyonlar
          </p>
          <span class="cc__top__content__mega-text">-</span>
        </div>
      </div>
      <div class="cc__bottom">
        <a href="#" class="cc__bottom__button">Tüm Liste</a>
      </div>
    </div>
  </div>

  <div class="card card__red m-t-30">
    <p class="body-heading">
      Vakfımız 03.01.2022 tarihi itibarıyla e-fatura mükellefi olmuştur.
    </p>
    <p class="body-heading">
      Mevcut uygulamamızda değişiklik olmadığından tüm fatura çıktıları fiziki
      olarak ekli belgeleri ile birlikte Vakfımıza gönderilmeye devam
      edilecektir.
    </p>
  </div>
</div>

<p
  class="p-30 pb-0"
  style="
    color: #001e3c;
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 38px;
  "
>
  Buttons
</p>
<!-- /* Typography */ -->
<div class="card">
  <p
    style="
      font-size: 18px;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 23px;
      color: #0054be;
    "
  >
    Default
  </p>
  <div class="add-process">
    <span class="far fa-plus"></span><span>Yeni İşlem Ekle</span>
  </div>
  <br />
  <br />
  <div class="link-icon">
    <span class="far fa-print"></span
    ><span>Provizyon Döküman Formu Yazdır</span>
  </div>
</div>

<!-- /* Typography */ -->
<div class="card">
  <p
    style="
      font-size: 18px;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 23px;
      color: #0054be;
    "
  >
    Hover
  </p>
  <div class="add-process add-process__hover">
    <span class="far fa-plus"></span><span>Yeni İşlem Ekle</span>
  </div>
  <br />
  <br />
  <div class="link-icon link-icon__hover">
    <span class="far fa-print"></span
    ><span>Provizyon Döküman Formu Yazdır</span>
  </div>
</div>

<div class="card">
  <p
    style="
      font-size: 18px;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 23px;
      color: #0054be;
    "
  >
    Modal
  </p>

  <div>
    <ng-template #content let-modal>
      <div class="modal-header mb-3">
        <p class="modal-title" id="modal-basic-title">Hizmet/Teşhis Ekleme</p>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span class="far fa-times" aria-hidden="true"></span>
        </button>
      </div>
      <hr class="card-hr mt-0 mb-3" />
      <div class="modal-body">
        <form class="theme-form">
          <div class="m-checkbox-inline mb-3">
            <div class="radio radio-primary">
              <input
                id="radioinline1"
                type="radio"
                name="radio1"
                value="option1"
                checked
              />
              <label class="mb-0" for="radioinline1">Teminat</label>
              <div class="checked-background"></div>
            </div>
            <div class="radio radio-primary">
              <input
                id="radioinline2"
                type="radio"
                name="radio1"
                value="option1"
              />
              <label class="mb-0" for="radioinline2">İlaç / Malzeme</label>
              <div class="checked-background"></div>
            </div>
            <div class="radio radio-primary">
              <input
                id="radioinline4"
                type="radio"
                name="radio1"
                value="option1"
              />
              <label class="mb-0" for="radioinline4">Diğer</label>
              <div class="checked-background"></div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-4">
              <div class="form-group m-b-15">
                <label class="label">Teminatlar</label>
                <select class="form-control">
                  <option selected>Tüm Teminatlar</option>
                  <option>Teminat 1</option>
                  <option>Teminat 2</option>
                  <option>Teminat 3</option>
                </select>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group m-b-15">
                <label class="label">Arama</label>
                <div class="text-icon">
                  <input
                    type="text"
                    placeholder="Kod, Teminat, Alt Teminat ile Arama"
                    class="form-control"
                  />
                  <span class="far fa-search"></span>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div
          class="table-responsive"
          style="max-height: 260px; overflow: scroll"
        >
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">Hizmet Ekle</th>
                <th scope="col">Kod</th>
                <th scope="col">Teminat</th>
                <th scope="col">Alt Teminat</th>
                <th scope="col">Tedavi</th>
                <th scope="col">İskonto Oranı</th>
                <th scope="col">Değer</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><span class="far fa-plus m-l-30"></span></td>
                <td>24.044</td>
                <td>Radyoloji</td>
                <td>Bilgisayarlı Tomogrofi(BT)</td>
                <td>Bilgisayarlı alt abonmen tomogrofisi(MD veya S)</td>
                <td>90</td>
                <td>100</td>
              </tr>
              <tr>
                <td><span class="far fa-plus m-l-30"></span></td>
                <td>24.044</td>
                <td>Radyoloji</td>
                <td>Bilgisayarlı Tomogrofi(BT)</td>
                <td>Bilgisayarlı alt abonmen tomogrofisi(MD veya S)</td>
                <td>90</td>
                <td>100</td>
              </tr>
              <tr>
                <td><span class="far fa-plus m-l-30"></span></td>
                <td>24.044</td>
                <td>Radyoloji</td>
                <td>Bilgisayarlı Tomogrofi(BT)</td>
                <td>Bilgisayarlı alt abonmen tomogrofisi(MD veya S)</td>
                <td>90</td>
                <td>100</td>
              </tr>
              <tr>
                <td><span class="far fa-plus m-l-30"></span></td>
                <td>24.044</td>
                <td>Radyoloji</td>
                <td>Bilgisayarlı Tomogrofi(BT)</td>
                <td>Bilgisayarlı alt abonmen tomogrofisi(MD veya S)</td>
                <td>90</td>
                <td>100</td>
              </tr>
              <tr>
                <td><span class="far fa-plus m-l-30"></span></td>
                <td>24.044</td>
                <td>Radyoloji</td>
                <td>Bilgisayarlı Tomogrofi(BT)</td>
                <td>Bilgisayarlı alt abonmen tomogrofisi(MD veya S)</td>
                <td>90</td>
                <td>100</td>
              </tr>
              <tr>
                <td><span class="far fa-plus m-l-30"></span></td>
                <td>24.044</td>
                <td>Radyoloji</td>
                <td>Bilgisayarlı Tomogrofi(BT)</td>
                <td>Bilgisayarlı alt abonmen tomogrofisi(MD veya S)</td>
                <td>90</td>
                <td>100</td>
              </tr>
              <tr>
                <td><span class="far fa-plus m-l-30"></span></td>
                <td>24.044</td>
                <td>Radyoloji</td>
                <td>Bilgisayarlı Tomogrofi(BT)</td>
                <td>Bilgisayarlı alt abonmen tomogrofisi(MD veya S)</td>
                <td>90</td>
                <td>100</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="table-footer m-t-30 d-flex align-items-center justify-content-between"
        >
          <ngb-pagination
            [collectionSize]="90"
            [(page)]="page"
            [maxSize]="5"
            [rotate]="true"
            aria-label="Default pagination"
          ></ngb-pagination>
          <form class="theme-form">
            <div class="form-group">
              <select class="form-control pagination-select">
                <option selected>5</option>
                <option>10</option>
                <option>15</option>
                <option>20</option>
              </select>
            </div>
          </form>
        </div>
      </div>
    </ng-template>
    <ng-template #content2 let-modal>
      <div class="modal-header mb-3">
        <p class="modal-title" id="modal-basic-title">Hizmet/Teşhis Ekleme</p>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span class="far fa-times" aria-hidden="true"></span>
        </button>
      </div>
      <hr class="card-hr mt-0 mb-3" />
      <div class="modal-body">
        <form class="theme-form">
          <div class="m-checkbox-inline mb-3">
            <div class="radio radio-primary">
              <input
                id="radioinline1"
                type="radio"
                name="radio1"
                value="option1"
              />
              <label class="mb-0" for="radioinline1">Teminat</label>
              <div class="checked-background"></div>
            </div>
            <div class="radio radio-primary">
              <input
                id="radioinline2"
                type="radio"
                name="radio1"
                value="option1"
                checked
              />
              <label class="mb-0" for="radioinline2">İlaç / Malzeme</label>
              <div class="checked-background"></div>
            </div>
            <div class="radio radio-primary">
              <input
                id="radioinline4"
                type="radio"
                name="radio1"
                value="option1"
              />
              <label class="mb-0" for="radioinline4">Diğer</label>
              <div class="checked-background"></div>
            </div>
          </div>
          <div class="row align-items-end">
            <div class="col-lg-4">
              <div class="form-group m-b-0">
                <label class="label">İlaç/Malzeme</label>
                <select class="form-control" required>
                  <option value="" default selected hidden>Seçiniz</option>
                  <option>A</option>
                  <option>B</option>
                  <option>C</option>
                </select>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group m-b-0">
                <label class="label">Tutar(KDV'siz)</label>
                <input
                  type="text"
                  placeholder="Giriş Yapınız"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-lg-4">
              <button class="btn btn-success float-right" disabled>
                <span>Ekle</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </ng-template>
    <button class="btn btn-lg btn-outline-primary" (click)="open(content)">
      <span>Open Modal-1</span>
    </button>
    <button
      class="btn btn-lg btn-outline-primary m-l-15"
      (click)="open2(content2)"
    >
      <span>Open Modal-2</span>
    </button>
    <br /><br />
    <p
      style="
        font-size: 18px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 23px;
        color: #0054be;
      "
    >
      Mesaj Paneli
    </p>
    <ng-template #content3 let-modal>
      <div class="modal-header mb-3">
        <p class="modal-title" id="modal-basic-title">Mesaj Paneli</p>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span class="far fa-times" aria-hidden="true"></span>
        </button>
      </div>
      <hr class="card-hr mt-0 mb-3" />
      <div class="modal-body">
        <h3 class="m-b-20">
          323943 Numaralı Seanslı İşlem Hak Talebi Mesajları
        </h3>
        <div class="message-box m-b-30">
          <div class="message-box__item active">
            <div class="message-box__item__left">
              <div class="message-box__item__left__case">
                <i class="fas fa-circle active"></i>
              </div>
              <div class="message-box__item__left__content">
                <p class="message-box__item__left__content__title">
                  Talep reddedildi
                </p>
                <p class="message-box__item__left__content__desc">
                  Yanlış evrak gönderimi sebebiyle hak talebi reddedilmiştir.
                </p>
                <p class="message-box__item__left__content__info">
                  Erdem Güneş - 0216 503 54 36 - 5467
                </p>
              </div>
            </div>
            <div class="message-box__item__right">
              <div class="message-box__item__right__top">
                <p class="message-box__item__right__top__date">
                  22.09.2022 - 10:30
                </p>
              </div>
              <button class="btn btn-outline-info"><span>Cevapla</span></button>
            </div>
          </div>
          <div class="message-box__item">
            <div class="message-box__item__left">
              <div class="message-box__item__left__case">
                <i class="fas fa-circle"></i>
              </div>
              <div class="message-box__item__left__content">
                <p class="message-box__item__left__content__title">
                  Talep reddedildi
                </p>
                <p class="message-box__item__left__content__desc">
                  Yanlış evrak gönderimi sebebiyle hak talebi reddedilmiştir.
                </p>
                <p class="message-box__item__left__content__info">
                  Erdem Güneş - 0216 503 54 36 - 5467
                </p>
              </div>
            </div>
            <div class="message-box__item__right">
              <div class="message-box__item__right__top">
                <p class="message-box__item__right__top__date">
                  22.09.2022 - 10:30
                </p>
                <p class="message-box__item__right__top__reader">
                  Okuyan: Seda Korkusuz
                </p>
              </div>
            </div>
          </div>
          <div class="message-box__item">
            <div class="message-box__item__left">
              <div class="message-box__item__left__case">
                <i class="fas fa-circle"></i>
              </div>
              <div class="message-box__item__left__content">
                <p class="message-box__item__left__content__title">
                  Talep reddedildi
                </p>
                <p class="message-box__item__left__content__desc">
                  Yanlış evrak gönderimi sebebiyle hak talebi reddedilmiştir.
                </p>
                <p class="message-box__item__left__content__info">
                  Erdem Güneş - 0216 503 54 36 - 5467
                </p>
              </div>
            </div>
            <div class="message-box__item__right">
              <div class="message-box__item__right__top">
                <p class="message-box__item__right__top__date">
                  22.09.2022 - 10:30
                </p>
                <p class="message-box__item__right__top__reader">
                  Okuyan: Seda Korkusuz
                </p>
              </div>
            </div>
          </div>
        </div>
        <h3 class="m-b-20">Yeni Mesaj Oluştur</h3>
        <form class="theme-form">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group mb-3">
                <label class="label">Adınız Soyadınız</label>
                <input
                  type="text"
                  placeholder="Giriş Yapınız"
                  class="form-control"
                />
              </div>
              <div class="form-group mb-3">
                <label class="label">İletişim Bilgileriniz</label>
                <input
                  type="text"
                  placeholder="Giriş Yapınız"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-3">
                <label class="label">Konu</label>
                <select class="form-control" required>
                  <option value="" default selected hidden>Seçiniz</option>
                  <option>Seçim 1</option>
                  <option>Seçim 2</option>
                  <option>Seçim 3</option>
                </select>
              </div>
              <div class="form-group mb-3">
                <label class="label">Mesaj</label>
                <textarea
                  rows="3"
                  class="form-control focus"
                  placeholder="Giriş Yapınız"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <div class="mb-3 m-r-30">
              <button class="btn btn-info"><span>Vazgeç</span></button>
            </div>
            <div class="mb-3">
              <button class="btn btn-success"><span>Gönder</span></button>
            </div>
          </div>
        </form>
      </div>
    </ng-template>

    <ng-template #content4 let-modal>
      <div class="modal-header mb-3">
        <p class="modal-title" id="modal-basic-title">Mesaj Paneli</p>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span class="far fa-times" aria-hidden="true"></span>
        </button>
      </div>
      <hr class="card-hr mt-0 mb-3" />
      <div class="modal-body">
        <h3 class="m-b-20">
          323943 Numaralı Seanslı İşlem Hak Talebi Mesajları
        </h3>
        <div class="message-box empty m-b-30">
          <span class="empty-text">Heünz gösterilecek mesaj yok</span>
        </div>
        <h3 class="m-b-20">Yeni Mesaj Oluştur</h3>
        <form class="theme-form">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group mb-3">
                <label class="label">Adınız Soyadınız</label>
                <input
                  type="text"
                  placeholder="Giriş Yapınız"
                  class="form-control"
                />
              </div>
              <div class="form-group mb-3">
                <label class="label">İletişim Bilgileriniz</label>
                <input
                  type="text"
                  placeholder="Giriş Yapınız"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-3">
                <label class="label">Konu</label>
                <select class="form-control" required>
                  <option value="" default selected hidden>Seçiniz</option>
                  <option>Seçim 1</option>
                  <option>Seçim 2</option>
                  <option>Seçim 3</option>
                </select>
              </div>
              <div class="form-group mb-3">
                <label class="label">Mesaj</label>
                <textarea
                  rows="3"
                  class="form-control focus"
                  placeholder="Giriş Yapınız"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <div class="mb-3 m-r-30">
              <button class="btn btn-info"><span>Vazgeç</span></button>
            </div>
            <div class="mb-3">
              <button class="btn btn-success"><span>Gönder</span></button>
            </div>
          </div>
        </form>
      </div>
    </ng-template>

    <ng-template #content5 let-modal>
      <div class="modal-header mb-3">
        <p class="modal-title" id="modal-basic-title">Hizmet işlemi Tutarı</p>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span class="far fa-times" aria-hidden="true"></span>
        </button>
      </div>
      <hr class="card-hr mt-0 mb-3" />
      <div class="modal-body">
        <h3 class="m-b-20">İlaç</h3>
        <form class="theme-form">
          <div class="form-group mb-3">
            <label class="label">Hesaplanan Tutar ( KDV’siz)</label>
            <input type="text" disabled value="1.783,78" class="form-control" />
          </div>
          <div class="form-group mb-3">
            <label class="label">Ödenecek Tutar ( KDV’siz)</label>
            <input
              type="text"
              placeholder="Giriş Yapınız"
              class="form-control"
            />
          </div>
          <div class="form-group mb-3">
            <label class="label">Red Tutar ( KDV’siz)</label>
            <input type="text" disabled value="0" class="form-control" />
          </div>
          <div class="form-group mb-3">
            <label class="label">Açıklama</label>
            <textarea
              rows="3"
              class="form-control focus"
              placeholder="Giriş Yapınız"
            ></textarea>
          </div>
          <div class="d-flex justify-content-end">
            <div class="mb-3 m-r-30">
              <button class="btn btn-info"><span>Vazgeç</span></button>
            </div>
            <div class="mb-3">
              <button class="btn btn-success">
                <span>Kaydı Güncelle</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </ng-template>

    <button class="btn btn-lg btn-outline-primary" (click)="open3(content3)">
      <span>Mesaj Paneli Liste</span>
    </button>
    <button
      class="btn btn-lg btn-outline-primary m-l-15"
      (click)="open4(content4)"
    >
      <span>Mesaj Paneli Boş Liste</span>
    </button>
    <button
      class="btn btn-lg btn-outline-primary m-l-15"
      (click)="open5(content5)"
    >
      <span>Hizmet İşlemi Tutarı</span>
    </button>

    <br />
    <br />
    <p
      style="
        font-size: 18px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 23px;
        color: #0054be;
      "
    >
      Optik Tablo
    </p>
    <ng-template #content6 let-modal>
      <div class="modal-header mb-3">
        <p class="modal-title" id="modal-basic-title">
          Optik Cam-Çerçeve Kayıt Formu
        </p>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span class="far fa-times" aria-hidden="true"></span>
        </button>
      </div>
      <hr class="card-hr mt-0 mb-3" />
      <div class="modal-body">
        <form class="theme-form">
          <div class="m-checkbox-inline mb-3">
            <div class="radio radio-primary">
              <input
                id="radioinline1"
                type="radio"
                name="radio1"
                value="option1"
                checked
              />
              <label class="mb-0" for="radioinline1"
                >Organik Antirefle Cam</label
              >
              <div class="checked-background"></div>
            </div>
            <div class="radio radio-primary">
              <input
                id="radioinline2"
                type="radio"
                name="radio1"
                value="option1"
              />
              <label class="mb-0" for="radioinline2">Progresif Cam</label>
              <div class="checked-background"></div>
            </div>
          </div>
          <div class="form-group mb-3 d-flex">
            <div class="checkbox">
              <input id="checkbox15" type="checkbox" />
              <label for="checkbox15">Uzak</label>
            </div>
            <div class="checkbox ml-4">
              <input id="checkbox16" type="checkbox" />
              <label for="checkbox16">Yakın</label>
            </div>
          </div>
        </form>

        <h3 class="m-b-20">Uzak Cam Bilgileri</h3>
        <div
          class="table-responsive"
          style="max-height: 260px; overflow: scroll"
        >
          <table class="table table-optik table-striped">
            <thead>
              <tr>
                <th scope="col"></th>
                <th scope="col">SPH</th>
                <th scope="col">CYL</th>
                <th scope="col">AKS</th>
                <th scope="col">Tutar</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><b>Sağ</b></td>
                <td>
                  <input
                    type="text"
                    placeholder="Giriş Yapınız"
                    class="form-control"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    placeholder="Giriş Yapınız"
                    class="form-control"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    placeholder="Giriş Yapınız"
                    class="form-control"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    placeholder="Giriş Yapınız"
                    class="form-control"
                  />
                </td>
              </tr>
              <tr>
                <td><b>Sol</b></td>
                <td>
                  <input
                    type="text"
                    placeholder="Giriş Yapınız"
                    class="form-control"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    placeholder="Giriş Yapınız"
                    class="form-control"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    placeholder="Giriş Yapınız"
                    class="form-control"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    placeholder="Giriş Yapınız"
                    class="form-control"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h3 class="m-b-20 m-t-30">Yakın Cam Bilgileri</h3>
        <div
          class="table-responsive"
          style="max-height: 260px; overflow: scroll"
        >
          <table class="table table-optik table-striped">
            <thead>
              <tr>
                <th scope="col"></th>
                <th scope="col">SPH</th>
                <th scope="col">CYL</th>
                <th scope="col">AKS</th>
                <th scope="col">Tutar</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><b>Sağ</b></td>
                <td>
                  <input
                    type="text"
                    placeholder="Giriş Yapınız"
                    class="form-control"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    placeholder="Giriş Yapınız"
                    class="form-control"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    placeholder="Giriş Yapınız"
                    class="form-control"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    placeholder="Giriş Yapınız"
                    class="form-control"
                  />
                </td>
              </tr>
              <tr>
                <td><b>Sol</b></td>
                <td>
                  <input
                    type="text"
                    placeholder="Giriş Yapınız"
                    class="form-control"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    placeholder="Giriş Yapınız"
                    class="form-control"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    placeholder="Giriş Yapınız"
                    class="form-control"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    placeholder="Giriş Yapınız"
                    class="form-control"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex align-items-end m-t-20">
          <div class="form-group mb-3 w-25">
            <label class="label">Çerçeve Tutarı</label>
            <input
              type="text"
              placeholder="Giriş Yapınız"
              class="form-control"
            />
          </div>
          <div class="form-group mb-3 m-l-40 d-flex">
            <div class="radio radio-primary">
              <input name="radio" id="radio15" type="radio" />
              <label for="radio15">Çerçeve var (Uzak)</label>
            </div>
            <div class="radio radio-primary ml-4">
              <input name="radio" id="radio16" checked type="radio" />
              <label for="radio16">Çerçeve var (Yakın)</label>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <div class="mb-3 m-r-30">
            <button class="btn btn-info"><span>Vazgeç</span></button>
          </div>
          <div class="mb-3">
            <button class="btn btn-success"><span>Kaydet</span></button>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #content7 let-modal>
      <div class="modal-header mb-3">
        <p class="modal-title" id="modal-basic-title">
          Optik Cam-Çerçeve Kayıt Formu
        </p>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span class="far fa-times" aria-hidden="true"></span>
        </button>
      </div>
      <hr class="card-hr mt-0 mb-3" />
      <div class="modal-body">
        <form class="theme-form">
          <div class="m-checkbox-inline mb-3">
            <div class="radio radio-primary">
              <input
                id="radioinline1"
                type="radio"
                name="radio1"
                value="option1"
              />
              <label class="mb-0" for="radioinline1"
                >Organik Antirefle Cam</label
              >
              <div class="checked-background"></div>
            </div>
            <div class="radio radio-primary">
              <input
                id="radioinline2"
                type="radio"
                name="radio1"
                value="option1"
                checked
              />
              <label class="mb-0" for="radioinline2">Progresif Cam</label>
              <div class="checked-background"></div>
            </div>
          </div>
          <div class="form-group mb-3 d-flex">
            <div class="radio radio-primary">
              <input name="radio10" id="radio17" checked type="radio" />
              <label for="radio17">Uzak</label>
            </div>
            <div class="radio radio-primary ml-4">
              <input name="radio10" id="radio18" type="radio" />
              <label for="radio18">Yakın</label>
            </div>
          </div>
        </form>

        <h3 class="m-b-20">Optik Cam Bilgileri</h3>
        <div
          class="table-responsive"
          style="max-height: 260px; overflow: scroll"
        >
          <table class="table table-optik table-striped">
            <thead>
              <tr>
                <th scope="col"></th>
                <th scope="col">SPH</th>
                <th scope="col">CYL</th>
                <th scope="col">AKS</th>
                <th scope="col">Tutar</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><b>Sağ</b></td>
                <td>
                  <input
                    type="text"
                    placeholder="Giriş Yapınız"
                    class="form-control"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    placeholder="Giriş Yapınız"
                    class="form-control"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    placeholder="Giriş Yapınız"
                    class="form-control"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    placeholder="Giriş Yapınız"
                    class="form-control"
                  />
                </td>
              </tr>
              <tr>
                <td><b>Sol</b></td>
                <td>
                  <input
                    type="text"
                    placeholder="Giriş Yapınız"
                    class="form-control"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    placeholder="Giriş Yapınız"
                    class="form-control"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    placeholder="Giriş Yapınız"
                    class="form-control"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    placeholder="Giriş Yapınız"
                    class="form-control"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="d-flex align-items-end m-t-20">
          <div class="form-group mb-3 w-25">
            <label class="label">Çerçeve Tutarı</label>
            <input
              type="text"
              placeholder="Giriş Yapınız"
              class="form-control"
            />
          </div>
          <div class="form-group mb-3 m-l-40 d-flex">
            <div class="checkbox">
              <input
                name="checkbox16"
                id="checkbox16"
                type="checkbox"
                checked
              />
              <label for="checkbox16">Çerçeve var</label>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <div class="mb-3 m-r-30">
            <button class="btn btn-info"><span>Vazgeç</span></button>
          </div>
          <div class="mb-3">
            <button class="btn btn-success"><span>Kaydet</span></button>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #content8 let-modal>
      <div class="modal-header mb-3">
        <p class="modal-title" id="modal-basic-title">Optik Lens Kayıt Formu</p>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span class="far fa-times" aria-hidden="true"></span>
        </button>
      </div>
      <hr class="card-hr mt-0 mb-3" />
      <div class="modal-body">
        <h3 class="m-b-20">Göz Numaraları ve Tutar Bilgisi</h3>
        <div class="row">
          <div class="col-lg-4">
            <div class="form-group mb-3">
              <label class="label">Sağ Göz</label>
              <input
                type="text"
                placeholder="Giriş Yapınız"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group mb-3">
              <label class="label">Sol Göz</label>
              <input
                type="text"
                placeholder="Giriş Yapınız"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group mb-3">
              <label class="label">Lens Tutarı</label>
              <input
                type="text"
                placeholder="Giriş Yapınız"
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <div class="mb-3 m-r-30">
            <button class="btn btn-info"><span>Vazgeç</span></button>
          </div>
          <div class="mb-3">
            <button class="btn btn-success"><span>Kaydet</span></button>
          </div>
        </div>
      </div>
    </ng-template>
    <button class="btn btn-lg btn-outline-primary" (click)="open6(content6)">
      <span>Optik Cam-Çerçeve Kayıt Formu-1</span>
    </button>
    <button
      class="btn btn-lg btn-outline-primary m-l-15"
      (click)="open7(content7)"
    >
      <span>Optik Cam-Çerçeve Kayıt Formu-2</span>
    </button>
    <button
      class="btn btn-lg btn-outline-primary m-l-15"
      (click)="open8(content8)"
    >
      <span>Optik Lens Kayıt Formu</span>
    </button>

    <br />
    <br />

    <p
      style="
        font-size: 18px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 23px;
        color: #0054be;
      "
    >
      Kullanıcı Ekle/Düzenle
    </p>
    <ng-template #content9 let-modal>
      <div class="modal-header mb-3">
        <p class="modal-title" id="modal-basic-title">Yeni Kayıt</p>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span class="far fa-times" aria-hidden="true"></span>
        </button>
      </div>
      <hr class="card-hr mt-0 mb-3" />
      <div class="modal-body">
        <form class="theme-form">
          <div class="form-group mb-3">
            <label class="label">Kullanıcı Tipi</label>
            <input
              type="text"
              disabled
              value="Kullanıcı"
              class="form-control"
            />
          </div>
          <div class="form-group mb-3">
            <label class="label">Yetki Grubu</label>
            <input
              type="text"
              disabled
              value="Kullanıcı (AT/YT/Seans/Diş)"
              class="form-control"
            />
          </div>
          <div class="form-group mb-3">
            <label class="label">Kullanıcı Adı Soyadı</label>
            <input
              type="text"
              placeholder="Giriş Yapınız"
              class="form-control"
            />
          </div>
          <div class="form-group mb-3">
            <label class="label">T.C. Kimlik No</label>
            <input
              type="text"
              placeholder="Giriş Yapınız"
              class="form-control"
            />
          </div>
          <div class="form-group mb-3">
            <label class="label">Telefon Numarası</label>
            <input
              type="text"
              placeholder="Giriş Yapınız"
              class="form-control"
            />
          </div>
          <div class="form-group mb-3">
            <label class="label">E-posta</label>
            <input
              type="email"
              placeholder="Giriş Yapınız"
              class="form-control"
            />
          </div>
          <div class="form-group mb-3 position-relative">
            <label class="label">Şifre</label>
            <input
              type="text"
              disabled
              value="Şifre Oluşturunuz"
              class="form-control"
            />
            <div class="create_password_icons">
              <div
                class="m-r-15"
                placement="bottom"
                ngbTooltip="Şifre oluşturmak için tıklayınız"
              >
                <svg
                  width="16px"
                  height="16px"
                  viewBox="0 0 16 16"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <title>58747030-1BC1-4AC9-AD83-36CCF954DDF8</title>
                  <g
                    id="UI-Kit"
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <g
                      id="Style-Sheet"
                      transform="translate(-861.000000, -4879.000000)"
                      fill="#7F98A8"
                      fill-rule="nonzero"
                    >
                      <g
                        id="Group-20"
                        transform="translate(144.000000, 4862.000000)"
                      >
                        <g
                          id="icon/password_reset"
                          transform="translate(717.000000, 17.000000)"
                        >
                          <path
                            d="M9.16666667,4.66666667 L8.66666667,4.66666667 L8.66666667,3.33333333 C8.66666667,1.49533333 7.17133333,0 5.33333333,0 C3.49533333,0 2,1.49533333 2,3.33333333 L2,4.66666667 L1.5,4.66666667 C0.673333333,4.66666667 0,5.34 0,6.16666667 L0,11.8333333 C0,12.66 0.673333333,13.3333333 1.5,13.3333333 L8.03333333,13.3333333 C8.1,12.9533333 8.29333333,12.6133333 8.56,12.3466667 C8.12,11.7466667 8.02666667,10.92 8.40666667,10.22 C8.92,9.26666667 9.72,8.53333333 10.6666667,8.10666667 L10.6666667,6.16666667 C10.6666667,5.34 9.99333333,4.66666667 9.16666667,4.66666667 Z M3.33333333,3.33333333 C3.33333333,2.23066667 4.23066667,1.33333333 5.33333333,1.33333333 C6.436,1.33333333 7.33333333,2.23066667 7.33333333,3.33333333 L7.33333333,4.66666667 L3.33333333,4.66666667 L3.33333333,3.33333333 Z"
                            id="Shape"
                          ></path>
                          <path
                            d="M15.484,13.2533333 C15.16,13.0786667 14.756,13.1986667 14.5806667,13.522 C14.198,14.228 13.4646667,14.6666667 12.6666667,14.6666667 C12.2593333,14.6666667 11.8733333,14.5433333 11.536,14.3373333 L11.8533333,14.02 C11.996,13.8773333 12.0393333,13.662 11.962,13.4753333 C11.8846667,13.2886667 11.702,13.1666667 11.5,13.1666667 L9.83333333,13.1666667 C9.55733333,13.1666667 9.33333333,13.3906667 9.33333333,13.6666667 L9.33333333,15.3333333 C9.33333333,15.5353333 9.45533333,15.718 9.642,15.7953333 C9.704,15.8213333 9.76866667,15.8333333 9.83333333,15.8333333 C9.96333333,15.8333333 10.0913333,15.7826667 10.1866667,15.6866667 L10.5686667,15.3046667 C11.168,15.752 11.9006667,16 12.6666667,16 C13.9546667,16 15.1373333,15.294 15.7526667,14.1573333 C15.928,13.8333333 15.808,13.4293333 15.484,13.2533333 L15.484,13.2533333 Z"
                            id="Path"
                          ></path>
                          <path
                            d="M15.6913333,9.20466667 C15.5046667,9.12733333 15.2893333,9.17 15.1466667,9.31333333 L14.7646667,9.69533333 C14.1653333,9.248 13.4326667,9 12.6666667,9 C11.376,9 10.1933333,9.70933333 9.57933333,10.8506667 C9.40533333,11.1753333 9.52666667,11.5793333 9.85066667,11.7533333 C9.95133333,11.8073333 10.0593333,11.8326667 10.166,11.8326667 C10.4033333,11.8326667 10.6333333,11.7053333 10.754,11.482 C11.1346667,10.7733333 11.868,10.3333333 12.6666667,10.3333333 C13.074,10.3333333 13.46,10.4566667 13.7973333,10.6626667 L13.48,10.98 C13.3373333,11.1226667 13.294,11.338 13.3713333,11.5246667 C13.4486667,11.7113333 13.6313333,11.8333333 13.8333333,11.8333333 L15.5,11.8333333 C15.776,11.8333333 16,11.6093333 16,11.3333333 L16,9.66666667 C16,9.46466667 15.878,9.282 15.6913333,9.20466667 L15.6913333,9.20466667 Z"
                            id="Path"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <div
                placement="bottom"
                ngbTooltip="Şifre gizlemek için tıklayınız"
              >
                <svg
                  width="16px"
                  height="15px"
                  viewBox="0 0 16 15"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <title>306C23C8-85EA-4E66-929C-4039EADFCF78</title>
                  <g
                    id="UI-Kit"
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <g
                      id="Style-Sheet"
                      transform="translate(-791.000000, -4879.000000)"
                      fill="#7F98A8"
                      fill-rule="nonzero"
                    >
                      <g
                        id="Group-20"
                        transform="translate(144.000000, 4862.000000)"
                      >
                        <path
                          d="M660.72075,17.21975 C661.01375,16.92675 661.48875,16.92675 661.78175,17.21975 C662.07275,17.51375 662.07275,17.98875 661.77975,18.28175 L648.27975,31.78175 C648.13375,31.92875 647.94175,32.00175 647.74975,32.00175 C647.55775,32.00175 647.36575,31.92775 647.21975,31.78175 C646.92675,31.48875 646.92675,31.01375 647.21975,30.72075 L649.70375,28.23675 C648.57375,27.39175 647.64375,26.28375 647.00075,25.00075 C648.48675,22.03275 651.51175,20.00075 655.00075,20.00075 C655.89075,20.00075 656.74975,20.13275 657.56175,20.37875 Z M659.97075,21.53075 C661.24975,22.39975 662.29875,23.59475 663.00175,24.99975 C661.51575,27.96775 658.49075,29.99975 655.00175,29.99975 C653.95675,29.99975 652.95275,29.81675 652.01975,29.48175 L653.22075,28.28075 C653.79975,28.42575 654.39775,28.49975 655.00175,28.49975 C656.40075,28.49975 657.76475,28.10075 658.94575,27.34775 C659.88575,26.74875 660.68275,25.94575 661.28075,24.99975 C660.68275,24.05475 659.88575,23.25175 658.94575,22.65175 C658.92675,22.63875 658.90675,22.62675 658.88675,22.61475 Z M658.81275,22.68875 C658.93575,23.07275 659.00175,23.48175 659.00175,23.90575 C659.00175,26.11475 657.21075,27.90575 655.00175,27.90575 C654.57775,27.90575 654.16875,27.83975 653.78475,27.71675 Z M651.24275,22.53775 C651.18075,22.57475 651.11875,22.61275 651.05775,22.65175 C650.11775,23.25075 649.32075,24.05375 648.72275,24.99975 C649.26075,25.85075 649.96075,26.58575 650.77975,27.16175 L651.73175,26.20975 C651.27175,25.55875 651.00175,24.76475 651.00175,23.90675 C651.00175,23.42575 651.08675,22.96475 651.24275,22.53775 Z M653.50175,21.99975 C652.67375,21.99975 652.00175,22.67175 652.00175,23.49975 C652.00175,24.15975 652.42875,24.71975 653.02075,24.92075 L654.92275,23.01875 C654.72175,22.42575 654.16175,21.99975 653.50175,21.99975 Z"
                          id="icon/eyes_hide"
                        ></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </div>
          </div>
          <div class="form-group mb-3 d-flex">
            <div class="checkbox">
              <input id="checkbox25" type="checkbox" />
              <label for="checkbox25">Aktif</label>
            </div>
            <div class="checkbox ml-4">
              <input id="checkbox26" type="checkbox" />
              <label for="checkbox26">Kilitli</label>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <div class="mb-3 m-r-30">
              <button class="btn btn-info"><span>Vazgeç</span></button>
            </div>
            <div class="mb-3">
              <button class="btn btn-success"><span>Kaydet</span></button>
            </div>
          </div>
        </form>
      </div>
    </ng-template>

    <ng-template #content10 let-modal>
      <div class="modal-header mb-3">
        <p class="modal-title" id="modal-basic-title">Kullanıcı Düzenle</p>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span class="far fa-times" aria-hidden="true"></span>
        </button>
      </div>
      <hr class="card-hr mt-0 mb-3" />
      <div class="modal-body">
        <form class="theme-form">
          <div class="form-group mb-3">
            <label class="label">Kullanıcı Tipi</label>
            <input type="text" disabled value="Admin" class="form-control" />
          </div>
          <div class="form-group mb-3">
            <label class="label">Yetki Grubu</label>
            <input
              type="text"
              disabled
              value="Kullanıcı (AT/YT/Seans/Diş)"
              class="form-control"
            />
          </div>
          <div class="form-group mb-3">
            <label class="label">Kullanıcı Adı Soyadı</label>
            <input
              type="text"
              placeholder="Giriş Yapınız"
              value="Mehmet Türk"
              class="form-control"
            />
          </div>
          <div class="form-group mb-3">
            <label class="label">T.C. Kimlik No</label>
            <input
              type="text"
              placeholder="Giriş Yapınız"
              value="74467674403"
              class="form-control"
            />
          </div>
          <div class="form-group mb-3">
            <label class="label">Telefon Numarası</label>
            <input
              type="text"
              placeholder="Giriş Yapınız"
              value="+90 532 745 6753"
              class="form-control"
            />
          </div>
          <div class="form-group mb-3">
            <label class="label">E-posta</label>
            <input
              type="email"
              placeholder="Giriş Yapınız"
              value="mehmet.turk@halkbank.com.tr"
              class="form-control"
            />
          </div>
          <div class="form-group mb-3 d-flex">
            <div class="checkbox">
              <input id="checkbox25" type="checkbox" />
              <label for="checkbox25">Aktif</label>
            </div>
            <div class="checkbox ml-4">
              <input id="checkbox26" type="checkbox" />
              <label for="checkbox26">Kilitli</label>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <div class="mb-3 m-r-30">
              <button class="btn btn-info"><span>Vazgeç</span></button>
            </div>
            <div class="mb-3">
              <button class="btn btn-success">
                <span>Kaydı Güncelle</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </ng-template>

    <ng-template #content11 let-modal>
      <div class="modal-header mb-3">
        <p class="modal-title" id="modal-basic-title">E-posta Gönder</p>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span class="far fa-times" aria-hidden="true"></span>
        </button>
      </div>
      <hr class="card-hr mt-0 mb-3" />
      <div class="modal-body">
        <form class="theme-form">
          <p class="card-heading font-weight-normal mb-3">
            Aşağıdaki e-posta adresine ait kullanıcının bilgileri, kendisine
            mail olarak gönderilecektir.
          </p>
          <div class="form-group mb-3">
            <label class="label">E-posta</label>
            <input
              type="email"
              disabled
              placeholder="Giriş Yapınız"
              value="mehmet.turk@halkbank.com.tr"
              class="form-control"
            />
          </div>
          <div class="d-flex justify-content-end">
            <div class="mb-3 m-r-30">
              <button class="btn btn-info"><span>Vazgeç</span></button>
            </div>
            <div class="mb-3">
              <button class="btn btn-success"><span>Gönder</span></button>
            </div>
          </div>
        </form>
      </div>
    </ng-template>

    <ng-template #content12 let-modal>
      <div class="modal-header mb-3">
        <p class="modal-title" id="modal-basic-title">E-posta Gönder</p>
        <button
          type="button"
          class="close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          <span class="far fa-times" aria-hidden="true"></span>
        </button>
      </div>
      <hr class="card-hr mt-0 mb-3" />
      <div class="modal-body">
        <form class="theme-form">
          <p class="card-heading font-weight-normal mb-3">
            Kullanıcının şifresi sıfırlanacak ve yeni şifre aşağıda yer alan
            numarasına SMS olarak gönderilecektir.
          </p>
          <div class="form-group mb-3">
            <label class="label">Telefon Numarası</label>
            <input
              type="text"
              placeholder="Giriş Yapınız"
              disabled
              value="+90 532 745 6753"
              class="form-control"
            />
          </div>
          <div class="d-flex justify-content-end">
            <div class="mb-3 m-r-30">
              <button class="btn btn-info"><span>Vazgeç</span></button>
            </div>
            <div class="mb-3">
              <button class="btn btn-success">
                <span>Sıfırla ve Gönder</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </ng-template>
    <button class="btn btn-lg btn-outline-primary" (click)="open9(content9)">
      <span>Yeni Kayıt</span>
    </button>
    <button
      class="btn btn-lg btn-outline-primary m-l-15"
      (click)="open10(content10)"
    >
      <span>Kullanıcı Düzenle</span>
    </button>
    <button
      class="btn btn-lg btn-outline-primary m-l-15"
      (click)="open11(content11)"
    >
      <span>E-posta Gönder</span>
    </button>
    <button
      class="btn btn-lg btn-outline-primary m-l-15"
      (click)="open12(content12)"
    >
      <span>Şifre Sıfırla ve Gönder</span>
    </button>
  </div>
</div>

<p
  class="p-30 pb-0"
  style="
    color: #001e3c;
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 38px;
  "
>
  Documents
</p>
<div class="document">
  <div class="d-flex justify-content-between mb-4">
    <svg
      width="32px"
      height="46px"
      viewBox="0 0 32 46"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>E2164C30-7D6A-4259-9CF3-0566C13B2E8E@2x</title>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Style-Sheet-3" transform="translate(-148.000000, -5224.000000)">
          <g id="Group-5" transform="translate(124.000000, 5200.000000)">
            <g id="pdf" transform="translate(24.000000, 24.000000)">
              <path
                d="M5.57031571,0 L19.8757039,0 L32,13.5862198 L32,40.0115155 C32,43.3218481 29.5088603,46 26.4403346,46 L5.57031571,46 C2.49113969,46 0,43.3218481 0,40.0115155 L0,5.98848449 C0,2.67815186 2.49108562,0 5.57031571,0 L5.57031571,0 Z"
                id="Path"
                fill="#E5252A"
              ></path>
              <g
                id="Group"
                transform="translate(6.190411, 0.000000)"
                fill="#FFFFFF"
                fill-rule="nonzero"
              >
                <polygon
                  id="Path"
                  opacity="0.302"
                  points="13.6745885 0 13.6745885 13.4827646 25.809589 13.4827646"
                ></polygon>
                <path
                  d="M0,34.3218305 L0,25.9195279 L3.32510572,25.9195279 C4.1483674,25.9195279 4.80057576,26.1609039 5.29238109,26.6551638 C5.78418642,27.1379158 6.03011612,27.7931124 6.03011612,28.6091876 C6.03011612,29.4252629 5.78418642,30.0804595 5.29238109,30.5632115 C4.80057576,31.0574714 4.1483674,31.2988474 3.32510572,31.2988474 L1.99933436,31.2988474 L1.99933436,34.3218305 L0,34.3218305 Z M1.99933436,29.4712946 L3.10058472,29.4712946 C3.39992803,29.4712946 3.63515338,29.4023051 3.79555641,29.2414265 C3.95590538,29.0919978 4.04148611,28.8850874 4.04148611,28.6092458 C4.04148611,28.3334041 3.95595945,28.1264938 3.79555641,27.977065 C3.63520744,27.8161283 3.39998209,27.7471969 3.10058472,27.7471969 L1.99933436,27.7471969 L1.99933436,29.4712946 Z M6.85332374,34.3218305 L6.85332374,25.9195279 L9.6224521,25.9195279 C10.1677251,25.9195279 10.6809391,25.9999671 11.1620401,26.1724118 C11.6431411,26.3447983 12.0815328,26.5862324 12.4664028,26.9195557 C12.8513268,27.2413709 13.1613745,27.6781493 13.3858955,28.2298908 C13.5997121,28.7816323 13.7173518,29.4138131 13.7173518,30.1264331 C13.7173518,30.8276034 13.5997662,31.4597841 13.3858955,32.0114675 C13.1613745,32.563209 12.8513268,32.9999874 12.4664028,33.3218027 C12.0814787,33.6551259 11.6431411,33.8965019 11.1620401,34.0689465 C10.6809391,34.241333 10.1677251,34.3218305 9.6224521,34.3218305 L6.85332374,34.3218305 Z M8.80989476,32.4942776 L9.38722675,32.4942776 C9.69727441,32.4942776 9.98596744,32.4598119 10.2532518,32.3793145 C10.5098317,32.2988752 10.7557614,32.1724042 10.9909868,32.0000177 C11.2155078,31.8276312 11.3972655,31.586197 11.5255554,31.2643818 C11.6538454,30.9425665 11.7180175,30.5632115 11.7180175,30.1264331 C11.7180175,29.6781468 11.6538454,29.29885 11.5255554,28.9770347 C11.3972655,28.6552194 11.2155078,28.4138434 10.9909868,28.2413987 C10.7557614,28.0690122 10.5098858,27.9425412 10.2532518,27.8621019 C9.98596744,27.7816626 9.69727441,27.7471388 9.38722675,27.7471388 L8.80989476,27.7471388 L8.80989476,32.4942776 Z M14.7223712,34.3218305 L14.7223712,25.9195279 L20.2820366,25.9195279 L20.2820366,27.7471388 L16.7217055,27.7471388 L16.7217055,29.0919396 L19.5656562,29.0919396 L19.5656562,30.9080427 L16.7217055,30.9080427 L16.7217055,34.3218305 L14.7223712,34.3218305 Z"
                  id="Shape"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>F3A856DD-B5E7-4779-8869-F7AFA5173D70</title>
      <g
        id="UI-Kit"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Style-Sheet"
          transform="translate(-717.000000, -5051.000000)"
          fill="#B1B1B1"
          fill-rule="nonzero"
        >
          <g id="Group-21" transform="translate(144.000000, 5038.000000)">
            <path
              d="M596.977394,35.5005099 C596.977394,36.3286502 597.182816,37 596.355174,37 L573.910641,37 C573.082999,37 573,36.3286502 573,35.5005099 C573,34.6723696 573.082999,34.0010198 573.910641,34.0010198 L596.355174,34.0010198 C597.182816,34.0010198 596.977394,34.6723696 596.977394,35.5005099 Z M583.929056,30.7503127 C584.221702,31.043135 584.605153,31.1895227 584.988697,31.1895227 C585.372148,31.1895227 585.755786,31.0430881 586.048339,30.7503127 L591.921541,25 C592.506787,24.4144023 591.943172,23.9025631 591.357927,23.3169653 C590.772682,22.7313676 590.387456,22.2937952 589.802211,22.879393 L586.487284,26.0699354 L586.487284,13.701317 C586.487284,12.8731767 585.816339,13.0081582 584.988697,13.0081582 C584.161056,13.0081582 583.49011,12.8731767 583.49011,13.701317 L583.49011,26.0699354 L580.275084,22.879393 C579.689838,22.2937952 579.204713,22.7313676 578.619468,23.3169653 C578.034223,23.9025631 577.570508,24.4144023 578.155754,25 L583.929056,30.7503127 Z"
              id="icon/download"
              style="mix-blend-mode: normal"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  </div>
  <span class="document__title">Ayakta Tedavi Provizyon</span>
  <span class="document__size">10MB</span>
</div>
<p
  class="p-30 pb-0"
  style="
    color: #001e3c;
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 38px;
  "
>
  File Upload
</p>
<!-- /* Typography */ -->
<div class="card">
  <div
    class="dropzone dropzone-primary"
    [dropzone]="config"
    (init)="onUploadInit($event)"
    (error)="onUploadError($event)"
    (success)="onUploadSuccess($event)"
  >
    <div class="d-flex dropzone-content">
      <!--begin::Label
      <label class="dz-label">Upload Files:</label>
      end::Label-->

      <!--begin::Col-->
      <div>
        <!--begin::Dropzone-->
        <div class="dropzone-content__right">
          <!--begin::Controls-->
          <div class="dropzone-panel mb-lg-0 mb-2 text-lg-left">
            <a class="dropzone-select btn btn-lg btn-outline-primary"
              ><span class="far fa-paperclip">&nbsp;&nbsp;</span
              ><span>Dosya Yükle</span></a
            >
            <span class="form-text text-muted m-t-10"
              >En fazla 5 dosya yüklenebilir, dosya boyutu max 100 MB ve JPG,
              PNG türünde olmalıdır.</span
            >

            <div id="dropzoneItemTemplate" style="display: none">
              <div>
                <div class="dz-preview dz-file-preview">
                  <div class="d-flex justify-content-end dz-close-icon">
                    <i class="far fa-times" data-dz-remove></i>
                  </div>
                  <div class="dz-details media">
                    <div class="dz-img">
                      <img class="img-fluid" data-dz-thumbnail />
                    </div>
                    <div class="media-body">
                      <h6 class="dz-filename">
                        <span class="dz-title" data-dz-name></span>
                      </h6>
                      <div class="dz-size">(<span data-dz-size></span>)</div>
                      <div class="dz-progress">
                        <span class="dz-upload" data-dz-uploadprogress></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="dropzone-error" data-dz-errormessage></div>
              </div>
            </div>

            <div class="dz-message needsclick"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Dropzone -->

    <!-- End Dropzone -->
  </div>

  <!-- Sağ Sidebar -->

  <div class="customizer-links" [ngClass]="{ open: customizer != '' }" hidden>
    <div
      class="nav flex-column nac-pills"
      id="c-pills-tab"
      role="tablist"
      aria-orientation="vertical"
    >
      <a
        href="javascript:void(0)"
        class="nav-link"
        [ngClass]="{ 'active show': customizer == 'layout' }"
        (click)="Customizer('layout')"
      >
        <div class="settings"><i class="fa fa-solid fa-info"></i></div>
      </a>
    </div>
  </div>
  <div class="customizer-contain" [ngClass]="{ open: customizer != '' }">
    <div class="tab-content" id="c-pills-tabContent">
      <div class="customizer-header">
        <i class="icofont-close icon-close" (click)="Customizer('')"></i>
        <h3>Bilgilendirmeler</h3>
      </div>
      <div class="customizer-body">
        <div class="sidebar-accordion">
          <ngb-accordion #acc="ngbAccordion">
            <ngb-panel>
              <ng-template class="d-flex align-items-center" ngbPanelTitle>
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex flex-column">
                    <h4>Bilgilendirme 1</h4>
                  </div>

                  <div class="d-flex align-items-center">
                    <div class="ml-2">
                      <i class="far fa-chevron-down"></i>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ngbPanelContent>
                <p>
                  Nullam sed nisi nisi. Fusce gravida condimentum eros molestie
                  blandit. Suspendisse tristique sapien enim. Maecenas vel
                  faucibus ligula. Nulla nec accumsan sapien. Quisque ac mattis
                  nunc, a pretium velit. Vestibulum mi leo, lobortis in urna ut,
                  porta accumsan metus.
                </p>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
          <ngb-accordion #acc="ngbAccordion">
            <ngb-panel>
              <ng-template class="d-flex align-items-center" ngbPanelTitle>
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex flex-column">
                    <h4>Bilgilendirme 2</h4>
                  </div>

                  <div class="d-flex align-items-center">
                    <div class="ml-2">
                      <i class="far fa-chevron-down"></i>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ngbPanelContent>
                <p>
                  Nullam sed nisi nisi. Fusce gravida condimentum eros molestie
                  blandit. Suspendisse tristique sapien enim. Maecenas vel
                  faucibus ligula. Nulla nec accumsan sapien. Quisque ac mattis
                  nunc, a pretium velit. Vestibulum mi leo, lobortis in urna ut,
                  porta accumsan metus.
                </p>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
          <ngb-accordion #acc="ngbAccordion">
            <ngb-panel>
              <ng-template class="d-flex align-items-center" ngbPanelTitle>
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex flex-column">
                    <h4>Bilgilendirme 3</h4>
                  </div>

                  <div class="d-flex align-items-center">
                    <div class="ml-2">
                      <i class="far fa-chevron-down"></i>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ngbPanelContent>
                <p>
                  Nullam sed nisi nisi. Fusce gravida condimentum eros molestie
                  blandit. Suspendisse tristique sapien enim. Maecenas vel
                  faucibus ligula. Nulla nec accumsan sapien. Quisque ac mattis
                  nunc, a pretium velit. Vestibulum mi leo, lobortis in urna ut,
                  porta accumsan metus.
                </p>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
          <ngb-accordion #acc="ngbAccordion">
            <ngb-panel>
              <ng-template class="d-flex align-items-center" ngbPanelTitle>
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex flex-column">
                    <h4>Bilgilendirme 4</h4>
                  </div>

                  <div class="d-flex align-items-center">
                    <div class="ml-2">
                      <i class="far fa-chevron-down"></i>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ngbPanelContent>
                <p>
                  Nullam sed nisi nisi. Fusce gravida condimentum eros molestie
                  blandit. Suspendisse tristique sapien enim. Maecenas vel
                  faucibus ligula. Nulla nec accumsan sapien. Quisque ac mattis
                  nunc, a pretium velit. Vestibulum mi leo, lobortis in urna ut,
                  porta accumsan metus.
                </p>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
        </div>
      </div>
    </div>
  </div>
</div>
